import { Box, Divider, Grid, Typography } from "@mui/material";
import { CommonStyle } from "Components";
import { FormDataType } from "DataTypes/Form";
import CstmBtn from "Components/CstmBtn";
import { FC, useEffect, useState } from "react";
import { DataArr } from "./Data";
import { commonFormSwitch, ControlledBoxSizeSwitch } from "Utils/SwitchCases";
import { useNavigate } from "react-router-dom";
import { HandleChangeProps } from "DataTypes/Common";
import {
  ListInitialStateType,
  PatientInitialStateType,
  UserInitialStateType
} from "DataTypes/Redux";
import { useSelector } from "react-redux";
import PatientApi from "Service/Patient.api";
import DataFormatter from "Utils/DataFormatter";
import {
  GetUniqueObjArr,
  HandleFormChange,
  ValidateFormData,
} from "Utils/common";
import PatientFormatter from "Utils/Patient.Formatter";
import { RouteUrls } from "Constant/RouteUrls";
import { useDispatch } from "react-redux";
import { setAlertData } from "Redux/Screen/Action";
import { ActivityTimeLogType } from "DataTypes/Services/Patient.type";
import DateTime from "Utils/DateTime";
import CommonFormatter from "Utils/Common.Formatter";
import { FilterCareplanActivity } from "./Format";
import useMonthEndSchedulerWithSmartCountdown from
  "Hooks/useMonthEndSchedulerWithSmartCountdown";

const AddOnTimeLog: FC = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { patientInfo, patientOrg }: PatientInitialStateType = useSelector(
    (state: any) => state?.patient
  );
  const { myInfo }: UserInitialStateType = useSelector(
    (state: any) => state?.user
  );
  const {
    addTimeLogType,
    addRPMTimeLogType,
    trainingReq,
  }: ListInitialStateType = useSelector((state: any) => state?.list);
  const RPMTimeLogList = [...addTimeLogType, ...addRPMTimeLogType];
  const newPatientId = patientInfo.id;
  const [formData, setFormData] = useState<FormDataType[]>(
    JSON.parse(JSON.stringify(DataArr))
  );
  const [programList, setProgramList] = useState<ActivityTimeLogType[]>([]);
  const [cpObj, setCpObj] = useState<ActivityTimeLogType | null>(null);
  const [loading, setLoading] = useState(false);
  const patLocTZ = patientOrg.practiceLocationTimezone;
  const UserLocTZ = myInfo.timezone;
  const startDateMinVal = DateTime.OrgMonthStartDateTime(
    patLocTZ, myInfo.timezone
  );
  let endDateMaxVal = DateTime.CurrentDate() + ", 11:59 PM";
  if (DateTime.CheckTodayIsLastDayOfMonth()) {
    endDateMaxVal = DateTime.OrgMonthEndDateTime(
      patLocTZ, myInfo.timezone
    );
  }

  const { isInBuffer, countdown } = useMonthEndSchedulerWithSmartCountdown({
    orgTimezone: "Asia/Kolkata",
    showCountdownOnUI: true,
    bufferTimeInSec: 900
  });

  useEffect(() => {
    !isInBuffer && handleOnload();
  }, [isInBuffer])

  useEffect(() => {
    CommonFormatter.HandleNavArr({
      id: "patient-details",
      label: "Clinical Summary",
      path: `/${RouteUrls.hs}/${RouteUrls.patient}/` +
        `${patientInfo.id}/${RouteUrls.addonTime}`,
      level: 3,
      link: RouteUrls.addonTime,
      navType: "patient",
    });
  }, []);

  const handleOnload: () => void = async () => {
    const formArr: FormDataType[] = JSON.parse(JSON.stringify(formData));
    const timeLogActivityRes = await PatientApi.timeLogActivity({
      id1: newPatientId,
    });
    if (timeLogActivityRes?.success) {
      const activityFormateRes = PatientFormatter.ActivityTimeLogRes(
        timeLogActivityRes?.data
      );
      const filteredArr = FilterCareplanActivity(activityFormateRes);
      setProgramList(filteredArr);
      const uniquePgrmList = GetUniqueObjArr(filteredArr, "programId");
      const prgmDropData = DataFormatter.FormatDropdownData(
        uniquePgrmList,
        "programId",
        "abbreviation",
        "programId"
      );
      formArr[0].dropArr = prgmDropData;
      formArr[2].minVal = formArr[3].minVal = startDateMinVal;
      formArr[2].maxVal = formArr[3].maxVal = endDateMaxVal;
      formArr[5].value = "0";
      formArr[4].dropArr = addTimeLogType;
      formArr[6].dropArr = trainingReq;
      setFormData(formArr);
    }
  };

  const handleChange: (props: HandleChangeProps) => void = (props) => {
    const { value, id } = props;
    const newFormData: FormDataType[] = JSON.parse(JSON.stringify(formData));
    if (id == "programName") {
      const selectedPgrm = programList.filter((el) => el.programId == value);
      if (selectedPgrm && selectedPgrm.length > 1) {
        const activityDropArr = DataFormatter.FormatDropdownData(
          selectedPgrm,
          "careplanId",
          "activity",
          "activity"
        );
        newFormData[1].boxType = "single-select-drop";
        newFormData[1].validatetype = "dropdown";
        newFormData[1].dropArr = activityDropArr;
        newFormData[1].readOnly = false;
        newFormData[6].boxType = "single-select-drop";
        newFormData[6].required = true;
        newFormData[4].dropArr = RPMTimeLogList;
      } else {
        const find = selectedPgrm[0];
        setCpObj(find || null);
        newFormData[1].boxType = "input-box";
        newFormData[1].validatetype = "name";
        newFormData[1].readOnly = true;
        newFormData[1].value = find?.activity || "";
        newFormData[6].boxType =
          find?.abbreviation == "RPM" ? "single-select-drop" : "empty-block";
        newFormData[6].required = find?.abbreviation == "RPM" ? true : false;
        newFormData[4].dropArr =
          find?.abbreviation != "RPM" ? addTimeLogType : RPMTimeLogList;
      }
    }
    if (id == "activity") {
      const selectedPgrm = programList.find(
        (el) => el.programId == newFormData[0].value && el.activity == value
      );
      setCpObj(selectedPgrm || null);
    }
    if (id == "start-date-time") {
      newFormData[5].value = DateTime.CalculateDuration(
        DateTime.ValidDate(value),
        DateTime.ValidDate(newFormData[3].value)
      ).toString();
      newFormData[3].minVal = DateTime.ValidDate(value) || startDateMinVal;
    }
    if (id == "end-date-time") {
      newFormData[5].value = DateTime.CalculateDuration(
        DateTime.ValidDate(newFormData[2].value),
        DateTime.ValidDate(value)
      ).toString();
      newFormData[2].maxVal = DateTime.ValidDate(value) || endDateMaxVal;
    }
    setFormData(HandleFormChange(props, newFormData));
  };

  const handleSave: () => void = async () => {
    const newArr = ValidateFormData(formData);
    setFormData(newArr.formData);
    setLoading(true);
    if (!newArr.errorCheck && cpObj) {
      const payload = {
        careplanId: cpObj.careplanId,
        careplanRecurringId: cpObj?.careplanRecurringId,
        startDateTime: DateTime.LocalTZToUTCDateTime(
          DateTime.ValidDate(formData[2].value), UserLocTZ
        ),
        endDateTime: DateTime.LocalTZToUTCDateTime(
          DateTime.ValidDate(formData[3].value), UserLocTZ
        ),
        ...(formData[6].value && {
          interactiveCommunicationDone:
            formData[6].value == "Yes" ? true : false,
        }),
        notes: formData[7].value,
        reasons: formData[1].value,
        state: "addon time",
        type: formData[4].dropValue,
      };
      const res = await PatientApi.timeLog({
        id1: cpObj?.careplanId || null,
        data: payload,
      });
      if (res?.success) {
        dispatch(setAlertData(res?.alert));
        navigate(-1);
      }
    }
    setLoading(false);
  };

  return (
    <Box width="91%" sx={{ ...CommonStyle.sxWhiteCard }} overflow="auto">
      <Box sx={{ p: 2, ...CommonStyle.sxRowCenter }}>
        <Box width="70%">
          <Box sx={{ ...sxHead }}>
            <Box>
              <Box display={"flex"}>
                <Typography variant="body2" mr={0.5}>
                  {"Patient's Name:"}
                </Typography>
                <Typography variant="body2" fontWeight="bold">
                  {patientInfo.name}
                </Typography>
              </Box>
              <Box mx={3} display={"flex"}>
                <Typography variant="body2" mr={0.5}>
                  Organization Name:
                </Typography>
                <Typography variant="body2" fontWeight="bold">
                  {patientOrg.practiceName}
                </Typography>
              </Box>
            </Box>
            {countdown &&
              <Box display={"flex"}>
                <Typography variant="body2">
                  {isInBuffer ?
                    "Add on time will be unlocked in" :
                    "This month billing will be locked in"
                  }
                </Typography>
                <Typography variant="body2" fontWeight="bold">
                  {countdown}
                </Typography>
              </Box>
            }
          </Box>
          <Divider sx={{ color: "custom.main", my: 0.5 }} />
          <Grid container columnSpacing={2} sx={{ mb: 1 }}>
            {formData && formData.length > 0
              ? formData.map((el: FormDataType) => {
                return (
                  <Grid
                    key={el.id}
                    item
                    {...ControlledBoxSizeSwitch(el.boxSize)}
                  >
                    {commonFormSwitch({
                      formObj: {
                        ...el,
                        ...isInBuffer ? { readOnly: isInBuffer } : {},
                      },
                      onChange: (data) => handleChange(data),
                    })}
                  </Grid>
                );
              })
              : null}
          </Grid>
          <Typography variant="body2" fontWeight="bold">
            {"Note : Start Time, End Time and Created Time " +
              "will be converted and shown in Location's time zone."}
          </Typography>
          <Box sx={{ mt: 1, ...CommonStyle.sxRow }} justifyContent={"end"}>
            <CstmBtn
              label="save"
              sxProps={{ mr: 2 }}
              onClick={() => {
                handleSave();
              }}
              width="15%"
              disable={loading || isInBuffer}
            />
            <CstmBtn
              label="Cancel"
              onClick={() => navigate(`../${RouteUrls.clinicalSummary}`)}
              btnType="border"
              width="15%"
              disable={loading}
            />
          </Box>
        </Box>
      </Box>
    </Box>
  );
};
export default AddOnTimeLog;

const sxHead = {
  display: "flex",
  flexDirection: "row",
  justifyContent: "space-between",
  "& >div": {
    display: "flex",
    alignItems: "center",
    "& >p:first-of-type": {
      mr: 1,
    },
  },
};
